import { useFeature } from '@thesisedu/feature-react'

import { AssignmentsReactFeature } from './AssignmentsReactFeature'

export function useOptions() {
  return useFeature(AssignmentsReactFeature).options
}
